import { render } from "./TheHeader.vue?vue&type=template&id=616e589c&scoped=true"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=616e589c&lang=scss&scoped=true"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\100\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616e589c"]])

export default __exports__